import React from "react";

import { ProtocolCreateBriefContainer } from "../../containers/Protocols/Brief/CreateBrief";

export const ProtocolCreateView = () => {
    return (<ProtocolCreateBriefContainer />);
}